import { ModelResource } from './resource';
import { ApPortalSession } from '../models';

export class ApPortalSessions extends ModelResource<ApPortalSession> {
  model = ApPortalSession;

  resourcePath = 'v1/ap-portal-sessions';
}
